/** Route buttons for the signature box that is still open. */
export const ICS213RR_ROUTE_LABELS: Record<string, string> = {
  sectionChief:
    'Send for 7. Section Chief / Command Staff Approval: Completion',
  reslReview: 'Send for 8–9. RESL Review: Completion',
  logisticsApproval: 'Send for 10–14. Logistics: Completion',
  financeApproval: 'Send for 15–16. Finance: Completion',
};

export function routeLabelForSlot(slotId: string | undefined): string | null {
  if (!slotId) return null;
  return ICS213RR_ROUTE_LABELS[slotId] ?? null;
}
